/**
 * Auto-generated FontAwesome icon registry
 * Generated from Sanity content + hardcoded components at build time
 * DO NOT EDIT - Run `pnpm run generate-icons` to regenerate
 *
 * ⚡ This file contains ONLY the icon definitions used in your content
 * No imports from @fortawesome packages - prevents 3MB+ bundle bloat
 *
 * Icons found: 24 (18 solid, 6 regular)
 * Hardcoded icons: 13 (faAnchor (solid), faLink (regular), faBars (solid), faCheck (solid), faCircleCheck (regular), faCircleCheck (solid), faCheckCircle (regular), faChevronDown (solid), faClose (solid), faCopy (solid), faGlobe (regular), faAngleRight (solid), faSearch (solid))
 */

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

export type FontAwesomeStyle = 'solid' | 'regular'

// Hardcoded icons (used in components but not in Sanity)
const HARDCODED_ICONS_LIST = [
  'faAnchor (solid)',
  'faLink (regular)',
  'faBars (solid)',
  'faCheck (solid)',
  'faCircleCheck (regular)',
  'faCircleCheck (solid)',
  'faCheckCircle (regular)',
  'faChevronDown (solid)',
  'faClose (solid)',
  'faCopy (solid)',
  'faGlobe (regular)',
  'faAngleRight (solid)',
  'faSearch (solid)',
]

// Manual icon definitions - no package imports needed
const ICON_REGISTRY: Record<FontAwesomeStyle, Record<string, any>> = {
  solid: {
    faGear: {
      prefix: 'fas',
      iconName: 'gear',
      icon: [
        512,
        512,
        [9881, 'cog'],
        'f013',
        'M195.1 9.5C198.1-5.3 211.2-16 226.4-16l59.8 0c15.2 0 28.3 10.7 31.3 25.5L332 79.5c14.1 6 27.3 13.7 39.3 22.8l67.8-22.5c14.4-4.8 30.2 1.2 37.8 14.4l29.9 51.8c7.6 13.2 4.9 29.8-6.5 39.9L447 233.3c.9 7.4 1.3 15 1.3 22.7s-.5 15.3-1.3 22.7l53.4 47.5c11.4 10.1 14 26.8 6.5 39.9l-29.9 51.8c-7.6 13.1-23.4 19.2-37.8 14.4l-67.8-22.5c-12.1 9.1-25.3 16.7-39.3 22.8l-14.4 69.9c-3.1 14.9-16.2 25.5-31.3 25.5l-59.8 0c-15.2 0-28.3-10.7-31.3-25.5l-14.4-69.9c-14.1-6-27.2-13.7-39.3-22.8L73.5 432.3c-14.4 4.8-30.2-1.2-37.8-14.4L5.8 366.1c-7.6-13.2-4.9-29.8 6.5-39.9l53.4-47.5c-.9-7.4-1.3-15-1.3-22.7s.5-15.3 1.3-22.7L12.3 185.8c-11.4-10.1-14-26.8-6.5-39.9L35.7 94.1c7.6-13.2 23.4-19.2 37.8-14.4l67.8 22.5c12.1-9.1 25.3-16.7 39.3-22.8L195.1 9.5zM256.3 336a80 80 0 1 0 -.6-160 80 80 0 1 0 .6 160z',
      ],
    },
    faLockKeyhole: {
      prefix: 'fas',
      iconName: 'lock-keyhole',
      icon: [
        384,
        512,
        ['lock-alt'],
        'f30d',
        'M192 32c35.3 0 64 28.7 64 64l0 64-128 0 0-64c0-35.3 28.7-64 64-64zM64 96l0 64c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l0-64c0-70.7-57.3-128-128-128S64 25.3 64 96zM216 296l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z',
      ],
    },
    faCircleQuestion: {
      prefix: 'fas',
      iconName: 'circle-question',
      icon: [
        512,
        512,
        [62108, 'question-circle'],
        'f059',
        'M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-336c-17.7 0-32 14.3-32 32 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 47.2-36 67.2-56 74.5l0 3.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8.1c0-20.5 14.8-35.2 30.1-40.2 6.4-2.1 13.2-5.5 18.2-10.3 4.3-4.2 7.7-10 7.7-19.6 0-17.7-14.3-32-32-32zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z',
      ],
    },
    faHome: {
      prefix: 'fas',
      iconName: 'house',
      icon: [
        512,
        512,
        [127968, 63498, 63500, 'home', 'home-alt', 'home-lg-alt'],
        'f015',
        'M277.8 8.6c-12.3-11.4-31.3-11.4-43.5 0l-224 208c-9.6 9-12.8 22.9-8 35.1S18.8 272 32 272l16 0 0 176c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-176 16 0c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8-35.1l-224-208zM240 320l32 0c26.5 0 48 21.5 48 48l0 96-128 0 0-96c0-26.5 21.5-48 48-48z',
      ],
    },
    faGrid2: {
      prefix: 'fas',
      iconName: 'grid-2',
      icon: [
        448,
        512,
        [],
        'e196',
        'M192 80c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zm0 256c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zM256 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM448 336c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96z',
      ],
    },
    faWrench: {
      prefix: 'fas',
      iconName: 'wrench',
      icon: [
        576,
        512,
        [128295],
        'f0ad',
        'M509.4 98.6c7.6-7.6 20.3-5.7 24.1 4.3 6.8 17.7 10.5 37 10.5 57.1 0 88.4-71.6 160-160 160-17.5 0-34.4-2.8-50.2-8L146.9 498.9c-28.1 28.1-73.7 28.1-101.8 0s-28.1-73.7 0-101.8L232 210.2c-5.2-15.8-8-32.6-8-50.2 0-88.4 71.6-160 160-160 20.1 0 39.4 3.7 57.1 10.5 10 3.8 11.8 16.5 4.3 24.1l-88.7 88.7c-3 3-4.7 7.1-4.7 11.3l0 41.4c0 8.8 7.2 16 16 16l41.4 0c4.2 0 8.3-1.7 11.3-4.7l88.7-88.7z',
      ],
    },
    faWifi: {
      prefix: 'fas',
      iconName: 'wifi',
      icon: [
        576,
        512,
        ['wifi-3', 'wifi-strong'],
        'f1eb',
        'M288 96c-90.9 0-173.2 36-233.7 94.6-12.7 12.3-33 12-45.2-.7s-12-33 .7-45.2C81.7 74.9 179.9 32 288 32S494.3 74.9 566.3 144.7c12.7 12.3 13 32.6 .7 45.2s-32.6 13-45.2 .7C461.2 132 378.9 96 288 96zM240 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM168 326.2c-11.7 13.3-31.9 14.5-45.2 2.8s-14.5-31.9-2.8-45.2C161 237.4 221.1 208 288 208s127 29.4 168 75.8c11.7 13.3 10.4 33.5-2.8 45.2s-33.5 10.4-45.2-2.8C378.6 292.9 335.8 272 288 272s-90.6 20.9-120 54.2z',
      ],
    },
    faBattery2: {
      prefix: 'fas',
      iconName: 'battery-quarter',
      icon: [
        640,
        512,
        ['battery-2'],
        'f243',
        'M528 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l416 0zM112 64c-44.2 0-80 35.8-80 80l0 224c0 44.2 35.8 80 80 80l416 0c44.2 0 80-35.8 80-80l0-48c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80L112 64zm56 112c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-64 0z',
      ],
    },
    faArrowAltCircleRight: {
      prefix: 'fas',
      iconName: 'circle-right',
      icon: [
        512,
        512,
        [61838, 'arrow-alt-circle-right'],
        'f35a',
        'M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zm387.3 11.3l-104 104c-4.6 4.6-11.5 5.9-17.4 3.5S256 366.5 256 360l0-56-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-56c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l104 104c6.2 6.2 6.2 16.4 0 22.6z',
      ],
    },
    faAnchor: {
      prefix: 'fas',
      iconName: 'anchor',
      icon: [
        576,
        512,
        [9875],
        'f13d',
        'M288 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 96c0-53 43-96 96-96s96 43 96 96c0 41.8-26.7 77.4-64 90.5l0 257.9c62.9-14.3 110.2-69.7 111.9-136.5l-16.1 14.1c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9l64-56c9-7.9 22.6-7.9 31.6 0l64 56c10 8.7 11 23.9 2.3 33.9s-23.9 11-33.9 2.3L496 307.9C493.9 421 401.6 512 288 512S82.1 421 80 307.9L63.8 322.1c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9l64-56c9-7.9 22.6-7.9 31.6 0l64 56c10 8.7 11 23.9 2.3 33.9s-23.9 11-33.9 2.3l-16.1-14.1c1.8 66.8 49.1 122.2 111.9 136.5l0-257.9c-37.3-13.2-64-48.7-64-90.5z',
      ],
    },
    faBars: {
      prefix: 'fas',
      iconName: 'bars',
      icon: [
        448,
        512,
        ['navicon'],
        'f0c9',
        'M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z',
      ],
    },
    faCheck: {
      prefix: 'fas',
      iconName: 'check',
      icon: [
        448,
        512,
        [10003, 10004],
        'f00c',
        'M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z',
      ],
    },
    faCircleCheck: {
      prefix: 'fas',
      iconName: 'circle-check',
      icon: [
        512,
        512,
        [61533, 'check-circle'],
        'f058',
        'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM374 145.7c-10.7-7.8-25.7-5.4-33.5 5.3L221.1 315.2 169 263.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.8 7.5 18.8 7s13.4-4.1 17.5-9.8L379.3 179.2c7.8-10.7 5.4-25.7-5.3-33.5z',
      ],
    },
    faChevronDown: {
      prefix: 'fas',
      iconName: 'chevron-down',
      icon: [
        448,
        512,
        [],
        'f078',
        'M201.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 338.7 54.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z',
      ],
    },
    faClose: {
      prefix: 'fas',
      iconName: 'xmark',
      icon: [
        384,
        512,
        [128473, 10005, 10006, 10060, 215, 'close', 'multiply', 'remove', 'times'],
        'f00d',
        'M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z',
      ],
    },
    faCopy: {
      prefix: 'fas',
      iconName: 'copy',
      icon: [
        448,
        512,
        [],
        'f0c5',
        'M192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-200.6c0-17.4-7.1-34.1-19.7-46.2L370.6 17.8C358.7 6.4 342.8 0 326.3 0L192 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-64 0 0 16-192 0 0-256 16 0 0-64-16 0z',
      ],
    },
    faAngleRight: {
      prefix: 'fas',
      iconName: 'angle-right',
      icon: [
        256,
        512,
        [8250],
        'f105',
        'M247.1 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L179.2 256 41.9 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z',
      ],
    },
    faSearch: {
      prefix: 'fas',
      iconName: 'magnifying-glass',
      icon: [
        512,
        512,
        [128269, 'search'],
        'f002',
        'M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z',
      ],
    },
  },
  regular: {
    faGlobe: {
      prefix: 'far',
      iconName: 'globe',
      icon: [
        512,
        512,
        [127760],
        'f0ac',
        'M303.2 413c-21.5 43.7-41.4 51-47.2 51s-25.7-7.3-47.2-51c-17-34.5-29.2-81.6-32.1-133l158.6 0c-3 51.5-15.2 98.6-32.1 133zm32.1-181l-158.6 0c3-51.5 15.2-98.6 32.1-133 21.5-43.7 41.4-51 47.2-51s25.7 7.3 47.2 51c17 34.5 29.2 81.6 32.1 133zm48.1 48l79.2 0c-8.6 74.6-56.7 137.3-122.8 166.4 24-42.8 40.3-102.4 43.6-166.4zm79.2-48l-79.2 0c-3.3-64-19.6-123.6-43.6-166.4 66.1 29.2 114.2 91.8 122.8 166.4zm-334 0l-79.2 0c8.6-74.6 56.7-137.3 122.8-166.4-24 42.8-40.3 102.4-43.6 166.4zM49.4 280l79.2 0c3.3 64 19.6 123.6 43.6 166.4-66.1-29.2-114.2-91.8-122.8-166.4zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z',
      ],
    },
    faBadgeCheck: {
      prefix: 'far',
      iconName: 'badge-check',
      icon: [
        512,
        512,
        [],
        'f336',
        'M256 0c35.9 0 67.8 17 88.1 43.4 33-4.3 67.6 6.2 93 31.6s35.9 60 31.6 93C495 188.2 512 220.1 512 256s-17 67.8-43.4 88.1c4.3 33-6.2 67.6-31.6 93s-60 35.9-93 31.6C323.8 495 291.9 512 256 512s-67.8-17-88.1-43.4c-33 4.3-67.6-6.2-93-31.6s-35.9-60-31.6-93C17 323.8 0 291.9 0 256s17-67.8 43.4-88.1c-4.3-33 6.2-67.6 31.6-93s60-35.9 93-31.6C188.2 17 220.1 0 256 0zm0 48c-24.1 0-45.1 13.6-55.7 33.6-5.4 10.2-17.3 15.1-28.2 11.7-21.6-6.6-46.1-1.4-63.1 15.7S86.6 150.4 93.2 172c3.4 11-1.5 22.9-11.7 28.2-20 10.6-33.6 31.6-33.6 55.7s13.6 45.1 33.6 55.7c10.2 5.4 15.1 17.3 11.7 28.2-6.6 21.6-1.4 46.1 15.7 63.1s41.5 22.3 63.1 15.7c11-3.4 22.9 1.5 28.2 11.7 10.6 20 31.6 33.6 55.7 33.6s45.1-13.6 55.7-33.6c5.4-10.2 17.3-15.1 28.2-11.7 21.6 6.6 46 1.4 63.1-15.7 17-17 22.3-41.5 15.7-63.1-3.4-11 1.5-22.9 11.7-28.2 20-10.6 33.6-31.6 33.6-55.7s-13.6-45.1-33.6-55.7c-10.2-5.4-15.1-17.3-11.7-28.2 6.6-21.6 1.4-46.1-15.7-63.1S361.6 86.6 340 93.2c-11 3.4-22.9-1.5-28.2-11.7-10.6-20-31.6-33.6-55.7-33.6zm57.4 121.9c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5L249.8 338.9c-4.2 5.7-10.7 9.4-17.8 9.8s-14-2.2-18.9-7.3l-46.4-48c-9.2-9.5-9-24.7 .6-33.9s24.7-8.9 33.9 .6l26.5 27.4 85.6-117.7z',
      ],
    },
    faPiggyBank: {
      prefix: 'far',
      iconName: 'piggy-bank',
      icon: [
        576,
        512,
        [],
        'f4d3',
        'M192 64a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM40 286.5c0-72.9 47-133.2 114.9-167.5 6.2 15 14.9 28.7 25.5 40.6-56.9 27.7-92.4 76.2-92.4 126.9 0 45.8 27.8 87.3 75.9 114.6 7.5 4.3 12.1 12.2 12.1 20.9l0 34c0 4.4 3.6 8 8 8l30.1 0c2.9 0 5.6-1.6 7-4.2l9.4-17.4c4.7-8.7 14.2-13.6 24-12.4 10.9 1.3 22.1 2 33.6 2s22.7-.7 33.6-2c9.8-1.2 19.3 3.8 24 12.4l9.4 17.4c1.4 2.6 4.1 4.2 7 4.2l30.1 0c4.4 0 8-3.6 8-8l0-34c0-8.6 4.6-16.6 12.1-20.9 13.6-7.7 25.6-16.6 35.8-26.5 4.5-4.3 10.4-6.7 16.6-6.7l63.4 0 0-96-21.5 0c-10.7 0-20.1-7.1-23.1-17.3-3-10.2-7.3-20.1-13-29.6-3.5-5.9-4.4-13-2.3-19.5l19.2-61.5-7.4 0c-18.2 0-34.7 6.7-47.4 17.8-7.6 6.6-18.5 7.8-27.3 3-3.2-1.7-6.4-3.4-9.7-5 12.9-14.4 22.9-31.5 29.1-50.3 16.6-8.6 35.4-13.5 55.3-13.5l18.2 0c27 0 46.2 26.2 38.2 51.9L517 210c2.4 4.6 4.5 9.2 6.5 14l4.5 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-54.1 0c-8 7-16.7 13.6-25.9 19.5l0 20.5c0 30.9-25.1 56-56 56l-30.1 0c-20.6 0-39.5-11.3-49.3-29.4l-1.8-3.4c-15 1-30.7 1-45.7 0l-1.8 3.4c-9.8 18.1-28.7 29.4-49.3 29.4L184 512c-30.9 0-56-25.1-56-56l0-20.5c-52.4-34-88-86.4-88-149zM424 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM216 192l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z',
      ],
    },
    faLink: {
      prefix: 'far',
      iconName: 'link',
      icon: [
        576,
        512,
        [128279, 'chain'],
        'f0c1',
        'M427.5 88c-21.4 0-42.2 6.9-59.3 19.4-11.4-11.7-24.4-22.1-38.4-30.7 27-23.6 61.7-36.7 97.7-36.7 82 0 148.5 66.5 148.5 148.5 0 39.4-15.6 77.1-43.5 105l-79.1 79.1c-27.8 27.8-65.6 43.5-105 43.5-82 0-148.5-66.5-148.5-148.5 0-17.9 3.2-35.5 9.4-51.9 4.6-12.4 18.5-18.7 30.9-14.1S259 220 254.4 232.4c-4.2 11.1-6.4 23-6.4 35.2 0 55.5 45 100.5 100.5 100.5 26.6 0 52.2-10.6 71-29.4l79.1-79.1C517.4 240.6 528 215.1 528 188.5 528 133 483 88 427.5 88zm-200 56c-26.6 0-52.2 10.6-71 29.4L77.4 252.5c-18.8 18.8-29.4 44.4-29.4 71 0 55.5 45 100.5 100.5 100.5 21.4 0 42.2-6.9 59.3-19.4 11.4 11.8 24.4 22.1 38.4 30.7-27 23.6-61.7 36.7-97.7 36.7-82 0-148.5-66.5-148.5-148.5 0-39.4 15.6-77.1 43.5-105l79.1-79.1c27.8-27.8 65.6-43.5 105-43.5 82 0 148.5 66.5 148.5 148.5 0 17.9-3.2 35.5-9.4 51.9-4.6 12.4-18.5 18.7-30.9 14.1S317 292 321.6 279.6c4.2-11.1 6.4-23 6.4-35.1 0-55.5-45-100.5-100.5-100.5z',
      ],
    },
    faCircleCheck: {
      prefix: 'far',
      iconName: 'circle-check',
      icon: [
        512,
        512,
        [61533, 'check-circle'],
        'f058',
        'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm70.7 121.9c7.8-10.7 22.8-13.1 33.5-5.3 10.7 7.8 13.1 22.8 5.3 33.5L243.4 366.1c-4.1 5.7-10.5 9.3-17.5 9.8-7 .5-13.9-2-18.8-6.9l-55.9-55.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36 36 105.6-145.2z',
      ],
    },
    faCheckCircle: {
      prefix: 'far',
      iconName: 'circle-check',
      icon: [
        512,
        512,
        [61533, 'check-circle'],
        'f058',
        'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm70.7 121.9c7.8-10.7 22.8-13.1 33.5-5.3 10.7 7.8 13.1 22.8 5.3 33.5L243.4 366.1c-4.1 5.7-10.5 9.3-17.5 9.8-7 .5-13.9-2-18.8-6.9l-55.9-55.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36 36 105.6-145.2z',
      ],
    },
  },
}

export function getFontAwesomeIcon(
  name: string,
  style: FontAwesomeStyle = 'solid',
): IconDefinition | undefined {
  const icon = ICON_REGISTRY[style]?.[name] as IconDefinition | undefined

  if (!icon) {
    console.warn(
      `FontAwesome icon "${name}" (${style}) not found in registry.\n` +
        `  → If this icon is hardcoded in a component, add it to HARDCODED_ICONS in scripts/generate-icon-registry.ts\n` +
        `  → Then run: pnpm run generate-icons\n` +
        `  → Currently registered hardcoded icons: ${HARDCODED_ICONS_LIST.join(', ')}`,
    )
  }

  return icon
}
